import Http from '@/common/http'
export default class Store {
    static getCooperativeStoreConfig (param = {}) {
      return Http.post('/home/store/cooperative_store_config', param)
    }
    static getCooperativeStoreList (param = {}) {
      return Http.post('/home/store/cooperative_store_list', param)
    }
}

